/**
 * Paginates an array into pages of fixed size, with optional filter.
 * Callback has the same signature as Array.prototype.filter: (element, index, array) => boolean.
 *
 * @param {Array} array - Source array (not mutated)
 * @param {number} pageSize - Number of items per page (treated as 1 if < 1)
 * @param {Function} [filterCallback] - Optional filter: (element, index, array) => boolean
 * @returns {{ totalPages: number, pages: Array<Array>, pageIndices: number[] }}
 */
export const paginateArray = (array, pageSize, filterCallback) => {
  const safeSize = pageSize < 1 ? 1 : Math.floor(pageSize);
  const source = Array.isArray(array) ? array : [];
  const filtered = typeof filterCallback === 'function'
    ? source.filter(filterCallback)
    : source;

  if (filtered.length === 0) {
    return { totalPages: 0, pages: [], pageIndices: [] };
  }

  const totalPages = Math.ceil(filtered.length / safeSize);
  const pages = [];
  for (let i = 0; i < totalPages; i += 1) {
    pages.push(filtered.slice(i * safeSize, (i + 1) * safeSize));
  }
  const pageIndices = Array.from({ length: totalPages }, (_, i) => i);

  return { totalPages, pages, pageIndices };
};
